import ProductStrip from '_components/ProductStrip';
import type { AlgonomyPlacement } from '@components/global/Recommendations/Loader';

export interface AlgonomyPlacementCarouselProps {
  placement?: AlgonomyPlacement;
  coOpBrand?: string | null;
}

// coOpBrand is accepted via AlgonomyPlacementCarouselProps, ready for the
// follow-up GA4 ticket — it is not yet used in any tracking call.
const AlgonomyPlacementCarousel = ({
  placement,
}: AlgonomyPlacementCarouselProps) => {
  if (!placement) return null;
  return <ProductStrip placement={placement} />;
};

export default AlgonomyPlacementCarousel;
